import React from 'react'
import { Panel } from '@elements'

export const WYSIWYG = ({
  wysiwygHeading,
  wysiwygSubheading,
  wysiwyg,
  marginTop,
  marginBottom,
}) => {
  const pt =
    marginTop === `40`
      ? `pt-40`
      : marginTop === `32`
      ? `pt-32`
      : marginTop === `24`
      ? `pt-24`
      : `pt-0`
  const pb =
    marginBottom === `40`
      ? `pb-40`
      : marginBottom === `32`
      ? `pb-32`
      : marginBottom === `24`
      ? `pb-24`
      : `pb-0`
  return (
    <section>
      <Panel className={`${pt} ${pb}`}>
        {wysiwygHeading && (
          <h2 className="mt-16 font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
            {wysiwygHeading}
          </h2>
        )}
        {wysiwygSubheading && (
          <h3 className="text-center">{wysiwygSubheading}</h3>
        )}
        <div
          dangerouslySetInnerHTML={{ __html: wysiwyg }}
          className="mx-auto mt-10 prose prose-xl"
        ></div>
      </Panel>
    </section>
  )
}
